import { put, takeLatest, call, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import checkoutAPI from '../../api/checkout';
import { Types, Creators as CheckoutCreators } from '../../reducers/checkout';
import getState from '../../utils/getState';

function* createBillet({ seller }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const billet = yield call(checkoutAPI.createBillet, siteId, seller.getIn(['hash']));

    yield put(CheckoutCreators.createBilletSuccess(seller.getIn(['seller', 'id']), billet));
  } catch (error) {
    yield put(CheckoutCreators.createBilletError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.CREATE_BILLET_REQUEST, createBillet);
}
